import client from "../client";

export function getSectors(page?: number) {
  return client.get(`/api/v2/sectors${page ? `?page=${page}` : ""}`);
}
